/** Bootstrap-aligned breakpoints used across SCSS and React layout hooks. */
export const BREAKPOINT_MD = 768;
export const BREAKPOINT_LG = 992;
export const BREAKPOINT_XL = 1300;

export const mediaQueryUp = (breakpoint: "md" | "lg" | "xl") => {
  const value =
    breakpoint === "xl"
      ? BREAKPOINT_XL
      : breakpoint === "lg"
        ? BREAKPOINT_LG
        : BREAKPOINT_MD;
  return `(min-width: ${value}px)`;
};

export const mediaQueryDown = (breakpoint: "md" | "lg" | "xl") => {
  const value =
    breakpoint === "xl"
      ? BREAKPOINT_XL
      : breakpoint === "lg"
        ? BREAKPOINT_LG
        : BREAKPOINT_MD;
  return `(max-width: ${value - 1}px)`;
};
